import { writable, type Writable } from "svelte/store"

export type WrapperElType = HTMLDivElement
const wrapperElStore: Writable<WrapperElType> = writable()

export default wrapperElStore
